import React from "react";
import ReactDOM from "react-dom";
import ButtonLoader from "../loader/ButtonLoader";

const ConfirmationModel = ({
  onClose,
  confirmText,
  onConfirm,
  isLoading,
  subText,
}) => {
  return ReactDOM.createPortal(
    <>
      <div className="model" onClick={onClose}>
        <div
          className={`bg-white flex flex-col items-center justify-center drop-shadow-lg rounded-lg max-w-md min-h-40 py-8 px-6 mx-auto relative w-80 sm:w-full md:w-full`}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <h2
            className={`sm:text-[34px] text-[24px] font-Montserrat mb-1 text-center text-primaryBlack`}
          >
            Confirm {confirmText}?
          </h2>

          <p className={`text-sm font-Proxima text-center font-normal`}>
            {subText}
          </p>
          <div className="flex justify-end gap-2 pt-3">
            <button
              onClick={onClose}
              type="button"
              className="text-themeBtn flex items-center uppercase font-Proxima text-[15px]  justify-center px-6 py-1.5 rounded border border-themeBtn"
            >
              <span>Cancel</span>
            </button>
            <button
              type="submit"
              className={`flex items-center justify-center px-6 py-1.5 rounded font-normal font-Proxima text-[15px] uppercase shadow-[4px_4px_10px_rgba(0,0,0,0.2)] ${
                isLoading
                  ? "bg-disableThemeBtn "
                  : "border-2 border-themeBtn  rounded text-white bg-themeBtn"
              }`}
              disabled={isLoading}
              onClick={onConfirm}
            >
              {isLoading ? (
                <ButtonLoader removeTheme={true} />
              ) : (
                <span className="font-normal">Confirm</span>
              )}
            </button>
          </div>
        </div>
      </div>
    </>,
    document.getElementById("modal-root")
  );
};

export default ConfirmationModel;
